import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import htmlToPdfmake from 'html-to-pdfmake';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { ReportLabelPipe } from '../../../../../../core/pipes/report-label.pipe';
import { LabelKey } from '../../../../../../core/models/report-labels.model';
import { ReportLabelsService } from '../../../../../manage-settings/report-labels/report-labels.service';

@Component({
  selector: 'app-print-quick-guide',
  standalone: true,
  imports: [CommonModule, ReportLabelPipe],
  templateUrl: './print-quick-guide.component.html',
  styleUrl: './print-quick-guide.component.scss',
})
export class PrintQuickGuideComponent implements OnDestroy {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  quickGuideData: any = null;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  @Input() set dataquickGuideData(val: any) {
    this.quickGuideData = val;
    this.cd.detectChanges();
    this.initialized = true;
  }
  @ViewChild('pdfContent', { static: true }) pdfContent!: ElementRef;
  initialized = false;
  private readonly destroy$ = new Subject<void>();
  bipLable: string = LabelKey.BIP;

  constructor(
    private cd: ChangeDetectorRef,
    private reportLabelsService: ReportLabelsService
  ) {
    this.reportLabelsService.getLabelValue(LabelKey.BIP).subscribe(value => {
      this.bipLable = value;
    });
  }

  async printPDF() {
    if (this.quickGuideData) {
      const pdfContent = document.getElementById('pdf-data');
      if (pdfContent) {
        const pdfMakeContent = htmlToPdfmake(pdfContent.innerHTML);
        const documentDefinition: TDocumentDefinitions = {
          content: pdfMakeContent,
          pageMargins: [20, 20, 20, 20],
          footer: function (currentPage: number) {
            return {
              columns: [
                { text: '', alignment: 'left' },
                {
                  text: `Powered by Insights to Behavior®`,
                  alignment: 'center',
                },
                { text: `${currentPage}`, alignment: 'right' },
              ],
              margin: [15, 0, 10, 0],
              color: '#475467',
            };
          },
          styles: {
            desc: { fontSize: 12 },
            address: { fontSize: 12 },
            title: { fontSize: 12 },
            heading: { fontSize: 14 },
            datalabel: { color: '#475467' },
            dataValue: { color: '#475467' },
          },
          defaultStyle: {
            columnGap: 10,
            fontSize: 10,
          },
        };

        // Generate and download the PDF
        pdfMake
          .createPdf(documentDefinition)
          .download(
            `Quick_guide_${this.quickGuideData?.caseDetail.studentName}.pdf`
          );

        this.initialized = false;
        this.ngOnDestroy();
      }
    }
  }

  // Function to determine the max row count
  getMaxLength(item: any): number[] {
    const maxLength = Math.max(
      item.ProactiveStrategy.length,
      item.ReplacementBehavior.length,
      item.ReactiveStrategy.length
    );
    return Array(maxLength)
      .fill(0)
      .map((_, index) => index);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
